<template>
<div class="wrapper" v-if="items.length > 0">
  <WebSlider
      @slideItemClicked="goToTestemunho"
      :showdots="false"
      :items="items"/>
  <Button
      @click="goToTestemunhos"
      class="btn"
      :text="$translate('UMA_LANG_FACULDADE_VERMAIS')" />
</div>
</template>

<script>
import { WebSlider } from "umaui";
import Button from "../../components/Button.vue";
import axios from "../../axios.js";
import constants from "../../constants.js";

export default {
  name: "Testemunhos",
  inject:["id","i18n","language"],
  components: {
    WebSlider,
    Button
  },
  data(){
    return {
      items:[]
    }
  },
  created() {
    this.getTestemunhosForFaculdade();
  },
  methods:{
    goToTestemunhos(){
      let baseurl = import.meta.env.VITE_APP_SITE_URL;
      if(this.language == "en"){
        baseurl = baseurl+"/en";
      }
      window.location = baseurl + "/testemunhos?faculdadeid="+this.id;
    },
    goToTestemunho(testemunho){
      let baseurl = import.meta.env.VITE_APP_SITE_URL;
      if(this.language == "en"){
        baseurl = baseurl+"/en";
      }
      window.location = baseurl + "/testemunhos/"+testemunho.Name;
    },
    truncate(str, max, suffix){
      return str.length < max ?
          str :
          `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))}${suffix}`
    },
    getTestemunhosForFaculdade(){
      axios.get(`/faculdades/${this.id}/testemunhos?idioma=${this.language}`)
      .then(data => {
        this.items = data.data.map(el => {
          return {
            ...el,
            Depoimento: this.truncate(el.Depoimento,constants.maxChars," (...)")
          }
        })
      })
      .catch(error => console.log(error));
    }
  },
}
</script>

<style>
.botao.previous.artes-e-humanidades,
.botao.next.artes-e-humanidades{
  background: #9f9fda;
}

/*.testemunhoItem.artes-e-humanidades{
  color: #9f9fda;
}*/

</style>

<style scoped lang="scss">
@import "../../global";

.wrapper{
  padding-bottom: 90px;
  padding-top: 90px;
  background-color: #f2f2f2;
}
.btn{
  margin: 30px auto 0;
  display: block;
  width: 290px;
}

.btn{
  margin: 0 auto;
  background-color: #080647;
  border: 2px solid white;
  margin-top: 35px;
}

.btn:hover {
  background-color: white;
  color: #080647;
  border: 2px solid #080647;
  transition: 900ms ease-in-out;
}

@media (max-width: 839px) {

  .wrapper {
    padding-bottom: 20px;
    padding-top: 20px;
  }

  .testemunhoItem {
    margin-bottom: 0px;
  }

  .btn {
    margin-top: 5px;
    margin-bottom: 10px;
  }





}





.btn.artesehumanidades{
  background-color: $ahline;
}

.btn.ciênciasexactasedaengenharia{
  background-color: $ceeline;
}

.btn.ciênciassociais{
  background-color: $csline;
}

.btn.ciênciasdavida{
  background-color: $cvhline;
}

.btn.tecnologiasegestão{
  background-color: $tghline;
}

.btn.escolasuperiordesaúde{
  background-color: $ssline;
}
</style>